export default __webpack_public_path__ + "static/media/WINE6.88f9a0a5.jpg";